import { ApplicationState } from '@app/store'
import {
  IGlobalCompanyContactsState,
  IGlobalConfigurationState,
  selectCompanyContacts,
  selectConfiguration,
} from '@app/store/modules/global'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import AssignmentsListPage from '../components/AssignmentsListPage'
import {
  actionCreators,
  IAssignmentsListState,
  selectAssignedTo,
  selectDueDate,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectOrderBy,
  selectScope,
  selectSortOrder,
  selectStatus,
  selectTotalItems,
} from '../modules/assignmentsList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IAssignmentsListState &
      IGlobalCompanyContactsState &
      IGlobalConfigurationState &
      ICurrentUserState
  >({
    assignedTo: selectAssignedTo(),
    companyContacts: selectCompanyContacts(),
    configuration: selectConfiguration(),
    dueDate: selectDueDate(),
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    orderBy: selectOrderBy(),
    scope: selectScope(),
    sortOrder: selectSortOrder(),
    status: selectStatus(),
    totalItems: selectTotalItems(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(AssignmentsListPage)
